import styled from 'styled-components'
import {
  theme,
  px2rem,
  StyledExternalLink,
  BorderlessParagraphWithBlockSpans,
  InlineAddress
} from '../../../../../theme/Global'

export const LocationContentHeading = styled.div`
  text-transform: uppercase;
  color: ${theme.colors.text};
`

export const LocationContentContainer = styled.div`
  margin-bottom: 1.8rem;
  font-size: ${px2rem(18)}rem;
  
  ${LocationContentHeading},
  ${InlineAddress},
  ${BorderlessParagraphWithBlockSpans},
  ${StyledExternalLink} {
    font-size: inherit !important;
    font-weight: 600;
  }
`
